<template>
  <div class="qatabs">
    <a-tabs default-active-key="1" @change="callback" :tabBarStyle="{ color: '#84878D', height: '47px', 'font-weight': 600, marginBottom: '10px' }">
      <a-tab-pane key="1" tab="我的贴子">
        <post></post>
        <!-- <div>
          <span>筛选：</span>
          <a-select default-value="lucy" style="width: 310px">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
            <a-select-option value="disabled">
              Disabled
            </a-select-option>
          </a-select>
          <a-button type="primary" class="quiz">题问</a-button>
        </div>
        <div class="comments">
          <comment v-for="item in 3" :key="item"></comment>
          <a-pagination v-model="current" :total="50" show-less-items />
        </div> -->
      </a-tab-pane>
      <a-tab-pane key="2" tab="回复我的">
        <reply></reply>
      </a-tab-pane>
      <a-tab-pane key="3" tab="我的评论">
        <my-comment></my-comment>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import comment from '../components/Comment'
import post from './Post'
import reply from './Reply'
import MyComment from './MyComment.vue'
export default {
  name: '',
  data() {
    return {
      current: 2
    }
  },
  components: {
    comment,
    post,
    reply,
    MyComment
  },
  methods: {
    callback() {}
  }
}
</script>
<style lang="less" scoped>
.qatabs {
  /deep/ .ant-tabs-tab {
    font-size: 18px;
    font-weight: 500;
    line-height: 33px;
  }
}
// .quiz {
//   margin-left: 12px;
//   border-radius: 16px;
//   background-color: #1564ff;
// }
// .comments {
//   padding-bottom: 28px;
//   .ant-pagination {
//     margin-top: 18px;
//     text-align: center;
//   }
// }
// /deep/.ant-select-selection {
//   border-radius: 16px;
// }
/deep/.ant-tabs-nav {
  padding-left: 16px;
}
// /deep/.ant-tabs-tab {
//   padding: 4px 0px 19px;
//   font-size: 16px;
// }
// /deep/.ant-tabs-tab-active .ant-tabs-ink-bar {
//   color: #1564FF;
//   font-weight: bold;
//   background-color: #1564FF;
// }
/deep/ .ant-tabs-ink-bar {
  display: none;
  // height: 0;
}
/deep/ .ant-tabs-tab {
  padding: 0px 0 4px;
  margin: 0;
  line-height: 25px;
  margin-left: 10px;
  margin-right: 42px;
}
/deep/ .ant-tabs-tabpane {
  padding: 10px;
}
// /deep/.ant-list-item {
//   margin-bottom: 0 !important;
// }
</style>
